import React, { useState, useEffect } from "react";
import DashboardHome from "./dashboard/DashboardHome";
import PageManager from "./dashboard/PageManager";
import NavigationManager from "./dashboard/NavigationManager";
import SliderManager from "./dashboard/SliderManager";
import ContactFormData from "./dashboard/ContactFormData";
import CareerFormData from "./dashboard/CareerFormData";
import ContentManager from "./dashboard/ContentManager";
import ServicesManager from "./dashboard/ServicesManager";
import ProductsManager from "./dashboard/ProductsManager";
import SEOManager from "./dashboard/SEOManager";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginData, setLoginData] = useState({ username: "", password: "" });

  // Check authentication on component mount
  useEffect(() => {
    const authToken = localStorage.getItem("ncg-admin-token");
    if (authToken) {
      setIsAuthenticated(true);
    }
  }, []);

  // Handle admin login
  const handleLogin = async (e) => {
    e.preventDefault();

    // Simple authentication (in production, use proper JWT tokens)
    if (loginData.username === "admin" && loginData.password === "ncg2024") {
      localStorage.setItem("ncg-admin-token", "authenticated");
      setIsAuthenticated(true);
    } else {
      alert("Invalid credentials");
    }
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("ncg-admin-token");
    setIsAuthenticated(false);
    setActiveTab("pages");
  };

  // Login form
  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <div className="login-container">
          <div className="login-card">
            <div className="login-header">
              <h2>NCG Admin Dashboard</h2>
              <p>Please login to access the admin panel</p>
            </div>
            <form onSubmit={handleLogin} className="login-form">
              <div className="form-group">
                <label>Username:</label>
                <input
                  type="text"
                  value={loginData.username}
                  onChange={(e) =>
                    setLoginData({ ...loginData, username: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label>Password:</label>
                <input
                  type="password"
                  value={loginData.password}
                  onChange={(e) =>
                    setLoginData({ ...loginData, password: e.target.value })
                  }
                  required
                />
              </div>
              <button type="submit" className="login-btn">
                Login <i className="fas fa-sign-in-alt ms-2"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  // Dashboard navigation items
  const navItems = [
    { id: "dashboard", label: "Dashboard", icon: "fas fa-tachometer-alt" },
    { id: "pages", label: "Page Management", icon: "fas fa-file-alt" },
    {
      id: "navigation",
      label: "Navigation Management",
      icon: "fas fa-sitemap",
    },
    { id: "slider", label: "Slider Management", icon: "fas fa-images" },
    { id: "contact-data", label: "Contact Form Data", icon: "fas fa-envelope" },
    { id: "career-data", label: "Career Form Data", icon: "fas fa-briefcase" },
    { id: "services", label: "Services Management", icon: "fas fa-cogs" },
    { id: "products", label: "Products Management", icon: "fas fa-box" },
    { id: "content", label: "Content Management", icon: "fas fa-edit" },
    { id: "seo", label: "SEO Management", icon: "fas fa-search" },
  ];

  // Render active component
  const renderActiveComponent = () => {
    switch (activeTab) {
      case "dashboard":
        return <DashboardHome onNavigate={setActiveTab} />;
      case "pages":
        return <PageManager />;
      case "navigation":
        return <NavigationManager />;
      case "slider":
        return <SliderManager />;
      case "contact-data":
        return <ContactFormData />;
      case "career-data":
        return <CareerFormData />;
      case "services":
        return <ServicesManager />;
      case "products":
        return <ProductsManager />;
      case "content":
        return <ContentManager />;
      case "seo":
        return <SEOManager />;
      default:
        return <DashboardHome onNavigate={setActiveTab} />;
    }
  };

  return (
    <div className="admin-dashboard">
      {/* Dashboard Header */}
      <div className="dashboard-header">
        <div className="header-left">
          <h1>NCG Admin Dashboard</h1>
          <span className="dashboard-subtitle">Content Management System</span>
        </div>
        <div className="header-right">
          <button onClick={handleLogout} className="logout-btn">
            <i className="fas fa-sign-out-alt me-2"></i>
            Logout
          </button>
        </div>
      </div>

      <div className="dashboard-body">
        {/* Sidebar Navigation */}
        <div className="dashboard-sidebar">
          <nav className="sidebar-nav">
            {navItems.map((item) => (
              <button
                key={item.id}
                className={`nav-item ${activeTab === item.id ? "active" : ""}`}
                onClick={() => setActiveTab(item.id)}
              >
                <i className={`${item.icon} me-3`}></i>
                {item.label}
              </button>
            ))}
          </nav>

          {/* Sidebar Footer */}
          <div className="sidebar-footer">
            <p className="crafted-by">Crafted by: Drift developers</p>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="dashboard-content">{renderActiveComponent()}</div>
      </div>
    </div>
  );
};

export default Dashboard;
